import { render, staticRenderFns } from "./tiwen.vue?vue&type=template&id=be4ad5ba&scoped=true"
import script from "./tiwen.vue?vue&type=script&lang=js"
export * from "./tiwen.vue?vue&type=script&lang=js"
import style0 from "./tiwen.vue?vue&type=style&index=0&id=be4ad5ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4ad5ba",
  null
  
)

export default component.exports